export const GLOBAL_STATE = 'Calendar'

export const CALENDAR_EVENT = 'calendarEvent'
export const CALENDAR_EVENT_CREATE = 'calendarEventCreate'
export const CALENDAR_EVENT_LIST = 'calendarEventList'
export const CALENDAR_EVENT_LIST_STUDENT = 'calendarEventStudent'
export const CALENDAR_EVENT_ALL = 'calendarEventAll'
